import { FormControl } from '@chakra-ui/react';
import { useCallback } from 'react';
import { Toggle } from 'ui-components';
import { CONTENT_SEARCH_PARAMS } from '~/hooks/useContentSearch';

import { IContentSearchComponentProps } from '../ContentSearchFilter.types';

export const ContentSearchFilterPaidContentToggle: React.FC<
  IContentSearchComponentProps
> = ({ filters: { ads = false }, onChange, order, trackId, isDisabled }) => {
  const handleChange = useCallback(
    (checked: boolean) => onChange({ [CONTENT_SEARCH_PARAMS.ads]: checked }),
    [onChange],
  );

  return (
    <FormControl
      display="inline-flex"
      width="auto"
      alignItems="center"
      order={order}
      pointerEvents={isDisabled ? 'none' : 'auto'}
    >
      <Toggle
        id="mytalent-toggle"
        trackId={`${trackId}-${ads ? 'on' : 'off'}`}
        label="Paid Content"
        checked={ads}
        onChange={handleChange}
      />
    </FormControl>
  );
};
